import type { Lesson } from '../../schema.js';

export const FORK_LESSONS: Lesson[] = [
  {
    id: 'puzzle-fork',
    slug: 'puzzles-fork',
    title: 'Fork attack',
    audienceLevel: 'beginner',
    concepts: ['puzzles'],
    steps: [
      {
        kind: 'explain',
        title: 'One piece, two targets',
        body: 'A fork attacks two enemy pieces at once. Because the enemy king is the best target of all, a CHECKING fork forces the king to move and lets you grab the other piece for free.',
        narration: 'A checking fork wins material.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Fork the king and queen',
        body: 'Your knight can check the king and attack the queen at the same time.',
        fen: '2q3k1/8/2N5/8/8/8/8/6K1 w - - 0 1',
        answer: ['Ne7+'],
        solution: ['Ne7+', 'Kh8', 'Nxc8'],
        expect: 'win-material',
        tier: 1,
        hint: 'A check makes the king move first.',
        hintLadder: ['A check makes the king move first.', 'Find the knight move that checks and attacks the queen.', 'Ne7+ wins the queen next move!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Fork over the center',
        body: 'The black queen is far away. Fork it with your knight.',
        fen: '6k1/8/2N5/3q4/8/8/8/6K1 w - - 0 1',
        answer: ['Ne7+'],
        solution: ['Ne7+', 'Kh8', 'Nxd5'],
        expect: 'win-material',
        tier: 2,
        hint: 'Find a knight check from the center.',
        hintLadder: ['Find a knight check from the center.', 'The knight should attack the queen after checking.', 'Ne7+ wins the queen next move!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Knight from the edge',
        body: 'Your knight forks the king and the queen.',
        fen: '7k/4q3/8/8/5N2/8/8/6K1 w - - 0 1',
        answer: ['Ng6+'],
        solution: ['Ng6+', 'Kg8', 'Nxe7+'],
        expect: 'win-material',
        tier: 2,
        hint: 'Check from a square near the king.',
        hintLadder: ['Check from a square near the king.', 'The same move must attack the queen.', 'Ng6+ wins the queen next move!'],
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Fork a rook',
        body: 'This fork wins a rook instead of a queen. Find the check.',
        fen: '2r3k1/8/8/3N4/8/8/8/6K1 w - - 0 1',
        answer: ['Ne7+'],
        solution: ['Ne7+', 'Kh8', 'Nxc8'],
        expect: 'win-material',
        tier: 3,
        hint: 'The knight can hit the king and the rook.',
        hintLadder: ['The knight can hit the king and the rook.', 'Check first, then the rook falls.', 'Ne7+ wins the rook next move!'],
      },
    ],
  },
];
